import {
  MutationFunction,
  UseQueryResult,
  useQuery,
} from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { ApiPaginatedResponse, ApiResponse, apiClient, apiClientNoAuth } from "./_client";
import { OrganizationUser } from "./organizations";

export const useReceivedUserInvitations = (): UseQueryResult<
  OrganizationUser[]
> => {
  let url = `api/users/invitations/`;
  const q = useQuery<OrganizationUser[]>({
    queryKey: ["received-user-invitations"],
    refetchInterval: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
    queryFn: async () => {
      const response = await apiClient.get<
        never,
        AxiosResponse<OrganizationUser[]>
      >(url);
      return response.data;
    },
  });
  return q;
};

export const acceptUserInvitation: MutationFunction<any> = async (
  invitationId: string & any,
) => {
  const response = await apiClient.post<never, any>(
    `api/users/invitations/accept/?id=${invitationId}`,
  );
  return response;
};

export const rejectUserInvitation: MutationFunction<any> = async (
  invitationId: string & any,
) => {
  const response = await apiClient.post<never, any>(
    `api/users/invitations/reject/?id=${invitationId}`,
  );
  return response;
};

export const getInvitationData = async (
  invitationToken: string & any,
): Promise<AxiosResponse> => {
  const response = await apiClientNoAuth.get<
    never,
    AxiosResponse<OrganizationUser>
  >(`api/users/invite/${invitationToken}/`);
  return response;
};

export const acceptInvitationSignUp = async ({
  invitationToken,
  data,
}: {
  invitationToken: string & any;
  data: any;
}): Promise<ApiResponse> => {
  const response = await apiClientNoAuth.post<
    never,
    AxiosResponse<OrganizationUser>
  >(`api/users/invite/${invitationToken}/`, data);
  return response;
};

export type UserInvitationPaginatedResponse = ApiPaginatedResponse<OrganizationUser>;
